export const GUIDE_FLOW_TYPES = {
    DOWNTIME_GUIDE_FLOW: "DOWNTIME_GUIDE_FLOW",
    UPTIME_GUIDE_FLOW: "UPTIME_GUIDE_FLOW",
    DEFAULT : "DEFAULT"
};
